import BrokenImageIcon from '@mui/icons-material/BrokenImage'
import Stack from '@mui/material/Stack'
import { Highlight } from 'entities/Documents'

interface Props {
  srcs?: string[]
  highlights?: Highlight[]
  hidden?: boolean
  height?: number
}

export function PreviewDom({ srcs, highlights, hidden = false, height = 100 }: Props) {
  if (hidden) {
    return null
  }

  if (!highlights || highlights.length === 0)
    return (
      // Be careful: images can be reloaded on every focus changes
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          height: '100%',
          color: 'grey.500',
        }}
      >
        <BrokenImageIcon style={{ fontSize: '4em' }} /> 画像は存在しません
      </Stack>
    )
  const highlight = highlights[0]
  const detectedPage = highlight.detectedPage
  const coordinates = highlights.reduce(
    (acc, cur) => {
      if (!cur.coordinates) return acc
      const { top_left, bottom_right } = cur.coordinates // eslint-disable-line @typescript-eslint/naming-convention
      if (!top_left || !bottom_right) return acc
      return [
        acc[0] === 0 || acc[0] > top_left[0] ? top_left[0] : acc[0],
        acc[1] === 0 || acc[1] > top_left[1] ? top_left[1] : acc[1],
        acc[2] < bottom_right[0] ? bottom_right[0] : acc[2],
        acc[3] < bottom_right[1] ? bottom_right[1] : acc[3],
      ]
    },
    [0, 0, 0, 0] /* top-x, top-y, bottom-x, bottom-y*/,
  )
  const top_left = [coordinates[0], coordinates[1]] // eslint-disable-line @typescript-eslint/naming-convention
  const bottom_right = [coordinates[2], coordinates[3]] // eslint-disable-line @typescript-eslint/naming-convention
  const sWidth = bottom_right[0] - top_left[0]
  const sHeight = bottom_right[1] - top_left[1]
  // width is not calculated correctly on Safari
  const cssWidth = height * (sWidth / sHeight)

  return (
    <svg
      style={{
        maxHeight: height,
        maxWidth: '100%',
        width: cssWidth,
        display: !highlight ? 'none' : undefined,
      }}
      viewBox={`${top_left[0]} ${top_left[1]} ${sWidth} ${sHeight}`}
    >
      {srcs &&
        srcs.map((s, i) => (
          <image key={s} href={s} display={i !== detectedPage ? 'none' : undefined} />
        ))}
    </svg>
  )
}

export default PreviewDom
